import React, { useContext } from 'react';
import QuotePostLineContext from './QuotePostLineContext';

const QuotePostLinePrimary = ({ children }) => {
  const { handleToggle, showDetails, hasSecondary } = useContext(QuotePostLineContext);

  const renderToggleIcon = () => {
    if (!hasSecondary) {
      return null;
    }

    if (showDetails) {
      return <i className="fas fa-angle-down mr-1 fa-fw" style={{ color: '#666' }} />;
    }

    return <i className="fas fa-angle-right mr-1 fa-fw" style={{ color: '#666' }} />;
  };

  return (
    <div className="quote-line" onClick={handleToggle}>
      {renderToggleIcon()}
      {children}
    </div>
  );
};

export default QuotePostLinePrimary;
